module.exports = __webpack_public_path__ + "static/media/ANDROS ALLASSO STEP UP TRANSFORMER.4b04e4a6.png";